module.exports = __webpack_public_path__ + "static/especializado-prematuridade-626cf0b0ea1fb564633432b8ca62a2a5.jpg";